/**
 * AAA IDP CTA component for home page
 * 
 */
import React from 'react';
import './Cta.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Cta = props => {
  const {
    btnTitle,
    content,
    startApp,
    title
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: "Cta",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "content",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "title",
        children: title
      }), /*#__PURE__*/_jsx("div", {
        dangerouslySetInnerHTML: {
          __html: content
        }
      })]
    }), /*#__PURE__*/_jsx("a", {
      href: "#aaa-idp-start",
      className: "button",
      onClick: e => startApp(e, 'cta'),
      children: btnTitle
    })]
  });
};
Cta.defaultProps = {
  title: 'Succinct title',
  content: '<p>This is some HTML content</p>'
};
export default Cta;